import { errorDialog } from "../errorDialog";

export function registerErrorHandler(): Disposable {
  window.addEventListener("error", onerror);
  window.addEventListener("unhandledrejection", onrejection);

  return {
    [Symbol.dispose]: () => {
      window.removeEventListener("error", onerror);
      window.removeEventListener("unhandledrejection", onrejection);
    },
  };
}

function onerror(event: ErrorEvent): void {
  try {
    errorDialog(event.error);
  } catch (e) {
    console.error(event.error);
    console.error(e);
  }

  event.preventDefault();
}

function onrejection(event: PromiseRejectionEvent): void {
  try {
    errorDialog(event.reason);
  } catch (e) {
    console.error(event.reason);
    console.error(e);
  }

  event.preventDefault();
}
